import { render, staticRenderFns } from "./R-score-widget.vue?vue&type=template&id=eb043c16"
import script from "./R-score-widget.vue?vue&type=script&lang=js"
export * from "./R-score-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports